export default {
  generatePrefillTagForDisplay,
  generatePrefillTagForSave,
  generateSignaturePrefillTagForDisplay,
  generateSignaturePrefillTagForSave,
  prepareForDisplay,
  prepareForSave,
  parsePfString,
};

function generateSignaturePrefillTagForDisplay({ text, prefill }) {
  prefill = prefill.replace(/"/g, '\'');
  return `<pf_signature prefill="${prefill}" prefill_desc="${text}" class="mceNonEditable">${text}</pf_signature>`;
}

function generateSignaturePrefillTagForSave({ text, prefill }) {
  return `<pf_signature prefill="${prefill}" prefill_desc="${text}"/>`;
}

function generatePrefillTagForDisplay({ text, prefill }) {
  // use single quotes for prefill attribute to avoid conflicts with double quotes in the prefill value
  prefill = prefill.replace(/"/g, '\'');
  return `<pf prefill_desc="${text}" prefill="${prefill}" class="mceNonEditable">${text}</pf>`;
}

function generatePrefillTagForSave({ text, prefill }) {
  return `<pf prefill="${prefill}" prefill_desc="${text}"/>`;
}

function prepareForDisplay(
  text,
  { cleanVersionSevenTagsEnabled = false, acceptNotClosedTags = false } = {}
) {
  // Handle pf_signature tags first
  text = text.replace(
    /<pf_signature prefill="((?:[^"]|\\")*?)" prefill_desc="([^"]+)"\/>/g,
    (matched, prefill, text) => generateSignaturePrefillTagForDisplay({ text, prefill })
  );

  if (acceptNotClosedTags) {
    text = text.replace(
      /<pf_signature\s+prefill="([^"]+)" prefill_desc="([^"]+)">/g,
      (matched, prefill, text) => generateSignaturePrefillTagForDisplay({ text, prefill })
    );
  }

  //ex: turn <pf prefill_desc="Request - ID" prefill="Request|ID"/>
  // into <pf prefill_desc="Request - ID" prefill="Request|ID" class="mceNonEditable">Request - ID</pf>
  text = cleanTextInsideRegEx(
    getPfTagTextRegEx(),
    getPfTagRegexReplacementArray(),
    text
  );
  if (cleanVersionSevenTagsEnabled) text = cleanVersionSevenTags(text);
  text = text.replace(
    /<pf prefill_desc="([^"]+)" prefill="((?:[^"]|\\")*?)"\/>/g,
    (matched, text, prefill) => generatePrefillTagForDisplay({ text, prefill })
  );

  if (acceptNotClosedTags) {
    // account for the Request|LastMilestone prefill coming back as
    // <pf prefill="Request|LastMilestone" prefill_desc="Request - Last Milestone"> from the templates.
    text = text.replace(
      /<pf\s+prefill="([^"]+)" prefill_desc="([^"]+)">/g,
      (matched, prefill, text) =>
        generatePrefillTagForDisplay({ text, prefill })
    );
  }

  // sometimes tinymce switches order of attributes
  text = text.replace(
    /<pf prefill="((?:[^">]|"(?!>))*?)" prefill_desc="([^"]+)"\/>/g,
    (matched, prefill, text) => generatePrefillTagForDisplay({ text, prefill })
  );

  if (acceptNotClosedTags) {
    text = text.replace(
      /<pf\s+prefill_desc="([^"]+)" prefill="([^"]+)">/g,
      (matched, text, prefill) =>
        generatePrefillTagForDisplay({ text, prefill })
    );
  }

  return text;
}

function prepareForSave(text) {
  // Handle pf_signature tags
  text = text.replace(
    /<pf_signature prefill_desc="(.*?)" prefill="(.*?)" class="mceNonEditable">(.*?)<\/pf_signature>/g,
    (matched, prefill, text) => generateSignaturePrefillTagForSave({ text, prefill })
  );
  
  // sometimes tinymce switches order of attributes
  text = text.replace(
    /<pf_signature prefill="(.*?)" prefill_desc="(.*?)" class="mceNonEditable">(.*?)<\/pf_signature>/g,
    (matched, text, prefill) => generateSignaturePrefillTagForSave({ text, prefill })
  );

  //ex: turn <pf prefill_desc="Request - ID" prefill="Request|ID" class="mceNonEditable">Request - ID</pf>
  // into <pf prefill_desc="Request - ID" prefill="Request|ID"/>

  // Line breaks inside pf tags (/n and /r) were causing issues with dynamic name tags including additional characters at runtime
  text = cleanTextInsideRegEx(
    getPfTagTextRegEx(),
    getLineBreakReplacementStringArray(),
    text
  );
  text = text.replace(
    /<pf prefill_desc="(.*?)" prefill="(.*?)" class="mceNonEditable">(.*?)<\/pf>/g,
    (matched, text, prefill) => generatePrefillTagForSave({ text, prefill })
  );

  // sometimes tinymce switches order of attributes
  text = text.replace(
    /<pf prefill="(.*?)" prefill_desc="(.*?)" class="mceNonEditable">(.*?)<\/pf>/g,
    (matched, prefill, text) => generatePrefillTagForSave({ text, prefill })
  );

  return text;
}

function cleanTextInsideRegEx(regEx, replaceStringArray, text) {
  //sample replace all line breaks only in text inside of <pf and </pf>
  //sample regEx: /<pf([\s\S]*?)<\/pf>/g
  //sample replaceStringArray = [{"regEx":/\r\n/g, "replaceText":" "}, {"regEx":/\r/g, "replaceText":" "},{"regEx":/\n/g, "replaceText":" "}];
  const matches = [];
  let match;

  while ((match = regEx.exec(text)) !== null) {
    matches.push(match[0]);
  }
  for (const match of matches) {
    var matchString = match;
    var replaceString = match;
    for (var i = 0; i < replaceStringArray.length; i++) {
      replaceString = replaceString.replace(
        replaceStringArray[i].regEx,
        replaceStringArray[i].replaceText
      );
    }
    text = text.replace(matchString, replaceString);
  }
  return text;
}

function getPfTagTextRegEx() {
  // Updated to handle both pf and pf_signature tags
  var regEx = /<(pf|pf_signature)([\s\S]*?)<\/(pf|pf_signature)>/g;
  return regEx;
}

function getPfTagRegexReplacementArray() {
  var ReplacementStringArray = getLineBreakReplacementStringArray();
  ReplacementStringArray.push({
    regEx: / class=\"mceNonEditable\">(.*?)<\/pf>/g,
    replaceText: "/>",
  });
  ReplacementStringArray.push({
    regEx: / class="mceNonEditable">(.*?)<\/pf>/g,
    replaceText: "/>",
  });
  return ReplacementStringArray;
}

function getLineBreakReplacementStringArray() {
  var ReplacementStringArray = [
    { regEx: /\r\n/g, replaceText: " " },
    { regEx: /\r/g, replaceText: " " },
    { regEx: /\n/g, replaceText: " " },
  ];
  return ReplacementStringArray;
}

function cleanVersionSevenTags(text) {
  text = text.replace(/">/g, '"/>');
  text = text.replace(/<pf\s{2,}/g, "<pf ");
  text = text.replace(/\s{1,}\/>/g, "/>");
  return text;
}

const dynamicStringPartType = {
  LITERAL: "literal",
  PF_TAG: "pf-tag",
  SIGNATURE_TAG: "signature-tag",
  MAPPING_REFERENCE: "mapping-reference",
};

function normalizePfStringInput(str) {
  return cleanTextInsideRegEx(
    getPfTagTextRegEx(),
    getPfTagRegexReplacementArray(),
    str
  );
}

function parsePfString(str) {
  str = normalizePfStringInput(str);

  const parts = [];
  let cursor = 0;
  let ordinal = 0;

  const pushLiteralUntil = (endIndex) => {
    if (cursor >= endIndex) return;
    parts.push({
      type: dynamicStringPartType.LITERAL,
      input: str.substring(cursor, endIndex),
    });
    cursor = endIndex;
  };

  const pushPf = (match) => {
    const input = match.input;
    const [prefillType, prefillField, taskGuid] = match[1].split("|");
    const isSignature = input.includes('pf_signature');

    parts.push({
      type: isSignature ? dynamicStringPartType.SIGNATURE_TAG : dynamicStringPartType.PF_TAG,
      input,
      ordinal,
      prefillType,
      prefillField,
      ...(taskGuid ? { taskGuid } : {}),
    });
    cursor += input.length;
    ordinal += 1;
  };

  // Updated to handle both tag types
  const tagRegex = /<(pf|pf_signature)\s[^>]*>/g;
  const prefillRegex = /prefill=['"]([^"']*)['"]/;

  for (const tagMatch of str.matchAll(tagRegex)) {
    const input = tagMatch[0];
    const match = input.match(prefillRegex);
    if (!match) continue;

    pushLiteralUntil(tagMatch.index);
    pushPf(match);
  }
  pushLiteralUntil(str.length);

  return { input: str, parts };
}
